import styled from '@emotion/styled';
import themeGet from '@styled-system/theme-get';
import Card from '../Card';
import { StyledIcon } from '../../RoundIcon/styles';
import { StyledTag } from '../../Tag/styles';

export const StyledSubHeroBannerBlockWrapper = styled.article`
  .trust-logo-bar {
    margin-top: 4rem;
    padding: 0 32px;

    .styled-logos {
      justify-content: space-between;
    }

    @media (min-width: ${themeGet('breakpoint.breakpointTablet')}) {
      padding: 0 5rem;
    }

    @media (min-width: 1581px ) {
      padding: 0 11rem;
    }
  }
`

export const StyledSubHeroBannerBlock = styled.article`
  background-image: linear-gradient(to bottom, white 50%, ${themeGet('color.colorBlueLightest')} 50%);
  background-image: -o-linear-gradient(bottom, white 50%, ${themeGet('color.colorBlueLightest')} 50%);
  background-image: -moz-linear-gradient(bottom, white 50%, ${themeGet('color.colorBlueLightest')} 50%);
  background-image: -webkit-linear-gradient(bottom, white 50%, ${themeGet('color.colorBlueLightest')} 50%);
  background-image: -ms-linear-gradient(bottom, white 50%, ${themeGet('color.colorBlueLightest')} 50%);
  margin: 0!important;
  padding: 3rem 0;

  .sub-hero-banner--inner {
    margin: 0 auto;    
    background: white;    
    display: flex;
    flex-wrap: nowrap;
    -webkit-flex-wrap: nowrap;
    -ms-flex-wrap: nowrap;
    box-shadow: 0px 8px 24px rgba(18, 28, 45, 0.1);
    border-radius: 8px;
    justify-content: center;
    max-width: 560px;
    padding: 2rem;

    @media (min-width: 1088px) {
      margin: 0 5rem;
    }

    @media (min-width: 960px) {
      height: 150px;
      padding: 0 30px 0 20px;
      max-width: 1200px;
      margin: 0 auto;
    }

    @media (min-width: 1050px) {
      padding: 0 80px 0 0;
    }

    & > div {
      @media (min-width: 960px) {
        height: 150px;
        margin-top: 0;
      }
    }

    .sub-hero-banner--child-first {
      display: flex;
      

      @media (min-width: 960px) {
        min-width: 30%;
      }

      @media (min-width: 1480px) {

      }

      img {
        height: 150px!important;
        border-radius: 8px 0 0 8px;
        @media (max-width: 959px) { 
          border-radius: 5px;
        }
      }
    
      @media (max-width: 959px) { 
        padding: 0;
      }
    }

    .sub-hero-banner--child-mid {      
      display: flex;
      align-items: center;
      flex-grow: 1;
      padding: 1rem;
      text-align: center;
      width: 90%;

      @media (min-width: 960px) {
        width: 50%;
        text-align: left;
      }
      
      h2 {
        font-family: "Whitney Cond SSm A", "Whitney Cond SSm B", sans-serif;
        font-size: 28px;
        margin-bottom: 8px;
        color: #030b5d;
      }

      p {
        font-size: 12px!important;
        margin-bottom: 0;
        color: #030b5d;
      }
      
      @media (max-width: 400px) { 
        width: 100%;
      }
    
    }

    .sub-hero-banner--child-last {
      width: auto;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      font-size: 16px;
      font-weight: 500;
      flex-shrink: 0;
      margin-bottom: 0;

      a {
        color: #030b5d;
        display: inline-block;
        padding: .7rem 1.5rem;
        border-radius: 4px;
        border: 2px solid #030b5d;
        text-decoration: none;
        transition: all .2s ease-in-out;

        &:hover {
          color: ${themeGet('color.colorBlueDark')};
          background-color: ${themeGet('color.colorBlueLightest')};
          border-color: ${themeGet('color.colorBlueDark')};
        }
      }

      @media (min-width: 960px) {
        height: 150px;
      }
    }

    @media (max-width: 959px) {
      flex-direction: column;
      align-items: center;
      padding-top: 2rem;
      padding-bottom: 2rem;

      & > div:not(:first-child) {
        margin-top: 2rem;
      }
    }
  }

  @media (min-width: ${themeGet('breakpoint.breakpointTablet')}) {
    margin-top: 0;
    margin: 6rem 11rem 0;
  }

  @media (min-width: ${themeGet('breakpoint.breakpointTablet')}) and (max-width: 1580px) {
    margin: 6rem 5rem 0;
  }

  @media (min-width: ${themeGet('breakpoint.breakpointTablet')}) and (max-width: 1580px) {
  }
`;

export const StyledCards = styled.div`
  display: grid;
  grid-row-gap: ${themeGet('scale.scaleBase')};

  @media (min-width: ${themeGet('breakpoint.breakpointTablet')}) {
    grid-template-columns: repeat(2, 1fr);
    grid-column-gap: ${themeGet('scale.scaleUp05')};
    grid-row-gap: ${themeGet('scale.scaleUp07')};
  }
`;

export const StyledCard = styled(Card)`
  .resource-card__image-container{
    height: 30%;
    overflow: hidden;

    .gatsby-image-wrapper{
      height:100%;
    }
  }

  .resource-dot {
    height: 25px;
    width: 25px;
    background-color: green;
    border-radius: 50%;
    display: inline-block;
  }

  @media (min-width: ${themeGet('breakpoint.breakpointMobile')}) {

  }

  @media (min-width: ${themeGet('breakpoint.breakpointTablet')}) {

  }
`;